import { render, staticRenderFns } from "./GenericReportTemplate.vue?vue&type=template&id=192e727f"
import script from "./GenericReportTemplate.vue?vue&type=script&lang=js"
export * from "./GenericReportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports